/// <amd-module name="Build/Designer/Components/FileList" />
import * as React from "react";

import * as Resources from "Build/Designer/Resources";

import { format } from "VSS/Core/Util/String";

import { Icon } from "VSSUI/Icon";
import { IListItemDetails, List, ListItem } from "VSSUI/List";
import { ArrayItemProvider } from "VSSUI/Utilities/Provider";

export enum FileType {
    Yaml = "FileYML",
    Other = "FileCode",
}

export interface IFileListItem {
    name: string;
    description: string;
    type: FileType
}

export interface FileListProps {
    files: IFileListItem[];
}

export const FileList = (props: FileListProps): JSX.Element => {
    const renderRow = (
        index: number,
        item: IFileListItem,
        details: IListItemDetails<IFileListItem>,
        key?: string
    ): JSX.Element => {
        return (
            <ListItem key={key || "list-item" + index} index={index} details={details}>
                <Icon className="fileList-icon body-xl" iconName={item.type} />
                <div className="fileList-info flex-column">
                    <div className="fileList-name body-m">{item.name}</div>
                    <div className="fileList-description body-s secondary-text">{item.description}</div>
                </div>
            </ListItem>
        );
    }

    const itemProvider = new ArrayItemProvider(props.files);
    return (
        <div className="fileList flex-column">
            <label className="fileList-label">{format(Resources.FilesToBeAdded, props.files.length)}</label>
            <List
                className="section-content"
                itemProvider={itemProvider}
                renderRow={renderRow}
                width={"100%"} />
        </div>
    );
}